var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticStyle:{"width":"100%"}},[_c('iframe',{attrs:{"sandbox":"allow-same-origin allow-scripts allow-popups allow-forms","allowfullscreen":"","frameborder":"0","src":_vm.url}})])}
var staticRenderFns = []

export { render, staticRenderFns }